export default __webpack_public_path__ + "static/media/hemorragia_digestiva_alta.16b046bc.pdf";